<template>
    <div class="pagenation">
        <ul>
            <li @click="currentPageClick(current -1)" v-if="current != 1"><img src="https://www.kuailework.com/plugins/website/images/Group 3 Copy@2x.png" alt=""></li>
            <li v-if="current>=4 ">...</li>
            <li @click="currentPageClick(item)" :class="current == item?'active':''" v-for="item in pagenationList" :key="item">{{item}}</li>
            <li v-if="current <= lastPage-3 ">...</li>
            <li v-if="lastPage > 5" @click="currentPageClick(current + 1)"><img src="https://www.kuailework.com/plugins/website/images/Group 3@2x.png" alt=""></li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "pagenation",
        data(){
            return{
                pagenationList: [],
                lastPage: 0,
                current: 1
            }
        },
        props:{
            total: {
                default: 0,
            },
            size: {
                default: 12,
            },
            currentPage: {
                default: 1,
            },
        },
        watch:{
            total(v){
                this.lastPage = Math.ceil(this.total / this.size)
                this.setPagenationList()
            },
            currentPage(v){
                this.current = v
            }
        },
        methods:{
            currentPageClick(v){
                this.current = v
                this.offset = (v-1) * this.size
                // this.getList()
                this.setPagenationList()
                this.$emit('current-change',v)
            },
            setPagenationList(){
                let v = this.current
                if(this.lastPage >= 6){
                    if(v < 3){
                        this.pagenationList = [1,2,3,4,5]
                    }else if(v>=3 && v<= this.lastPage-2){
                        this.pagenationList = [v-2,v-1,v,v+1,v+2]
                    }else{
                        this.pagenationList = [this.lastPage-4,this.lastPage-3,this.lastPage-2,this.lastPage-1,this.lastPage]
                    }
                }else{
                    let list = []
                    for(var i=1;i<= this.lastPage;i++){
                        list.push(i)
                    }
                    this.pagenationList = list
                }
            }
        }
    }
</script>

<style scoped>
    .pagenation{
        width: 100%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .pagenation ul li{
        display: inline-block;
        margin: 0 5px;
        display: block;
        float: left;
        min-width: 50px;
        height: 48px;
        line-height: 48px;
        text-align: center;
        cursor: pointer;
        border: #ccc solid 1px;
        border-radius: 8px;
        color: #222;
    }
    .pagenation ul li:hover{
        color: #00b536;
    }
    .pagenation ul li.active{
        background: #00b536;
        color: #fff !important;
        cursor: default;
        border: none;
    }
</style>